import { SystemActorSchema } from '@/entities/common/SystemActor'
import { z } from '@/utils/zod'

export const BaseEntitySchema = z.object({
    _id: z.objectId(),
    createdAt: z.isoDateTime.nullish(),
    updatedAt: z.isoDateTime.nullish(),
    removedAt: z.isoDateTime.nullish(),
    createdBy: SystemActorSchema.or(z.string()).nullish(),
    updatedBy: SystemActorSchema.or(z.string()).nullish(),
    removedBy: SystemActorSchema.or(z.string()).nullish(),
})

export type BaseEntity = z.infer<typeof BaseEntitySchema>

export const EntitySchema = BaseEntitySchema.extend({
    createdBy: SystemActorSchema.nullish(),
    updatedBy: SystemActorSchema.nullish(),
    removedAt: z.never().optional(),
    removedBy: z.never().optional(),
})

export type Entity = z.infer<typeof EntitySchema>

export const OldEntitySchema = BaseEntitySchema.extend({
    createdBy: z.string().nullish(),
    updatedBy: z.string().nullish(),
    removedBy: z.string().nullish(),
})

export type OldEntity = z.infer<typeof OldEntitySchema>

export const TenantEntitySchema = EntitySchema.extend({
    tenant: z.objectId(),
})

export type TenantEntity = z.infer<typeof TenantEntitySchema>
